import { render, staticRenderFns } from "./DiagnosticBuilderEditorCard.vue?vue&type=template&id=6980597c&scoped=true&"
import script from "./DiagnosticBuilderEditorCard.vue?vue&type=script&lang=js&"
export * from "./DiagnosticBuilderEditorCard.vue?vue&type=script&lang=js&"
import style0 from "./DiagnosticBuilderEditorCard.vue?vue&type=style&index=0&id=6980597c&prod&lang=scss&scoped=true&"
import style1 from "./DiagnosticBuilderEditorCard.vue?vue&type=style&index=1&id=6980597c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6980597c",
  null
  
)

export default component.exports